import React from 'react';
import PropTypes from 'prop-types';
import AppConfig from 'Config/AppConfig';
import styles from '../Pages/LeadVettingPage/components/LeadVettingFormStyles.module.less';
import TranslationUtils from '../Utils/TranslationUtils';
import Enums from '../Constants/Enums';

const TermsCheckbox = (props) => {
  const getTermsURL = () => {
    if (props.product === Enums.PRODUCT_TYPE.API_PURCHASE || props.product === Enums.PRODUCT_TYPE.API_TRIAL) {
      return AppConfig.TERMS_AND_CONDITIONS_URL_SEARCH_API;
    }
    if (
      props.product === Enums.PRODUCT_TYPE.VERIFY_API_PURCHASE ||
      props.product === Enums.PRODUCT_TYPE.VERIFY_API_TRIAL
    ) {
      return AppConfig.TERMS_AND_CONDITIONS_URL_VERIFY_API;
    }

    return AppConfig.TERMS_AND_CONDITIONS_URL_SEARCH_UI;
  };

  return (
    <div className={styles.fieldRow}>
      <div className={styles.checkboxSection}>
        <div>
          <label htmlFor="terms-agree" className={styles.checkboxContainer}>
            <span className={styles.checkboxLabel}>
              {TranslationUtils.getText('AGREE_TO_TERMS')}{' '}
              <a target="_blank" href={getTermsURL()}>
                {TranslationUtils.getText('CONDITION_OF_USE')}
              </a>{' '}
              {TranslationUtils.getText('AND')}{' '}
              <a target="_blank" href="https://pipl.com/resources/privacy-documents/privacy-policy-individuals">
                {TranslationUtils.getText('PRIVACY_NOTICE')}
              </a>
            </span>
            <input
              type="checkbox"
              name="terms"
              onChange={props.onChange}
              checked={props.checked}
              test-id="input-terms"
              id="terms-agree"
            />
            <span className={styles.checkmark} />
          </label>
        </div>
      </div>
      {props.error && (
        <div test-id="error-terms" className="error-label terms">
          {props.error}
        </div>
      )}
    </div>
  );
};

TermsCheckbox.propTypes = {
  error: PropTypes.string,
  product: PropTypes.string,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
};

export default TermsCheckbox;
